<template>
<m-pageframe
    title="Test Attachments"
>
<v-container>

    Read Only:
    <m-edit-blobs
        v-model="blobs"
        read_only
        :externally_visible="true"
    />

    Editable:
    <m-edit-blobs
        v-model="blobs"
        :process_media="false"
        :externally_visible="true"
    />

    Blobs Id(s):
    <div
        style="margin-bottom: 15px"
    >
        <code style="display: block; white-space: pre;">
            {{blobs}}
        </code>
    </div>

    <div>
    <v-btn
        v-for="(item, index) in options"
        :key="index"
        v-on:click="blobs = item.value"
        style="margin-right: 15px;"
    >
        {{item.text}}
    </v-btn>
    </div>

</v-container>
</m-pageframe>
</template>

<script>
import EditBlobs from '../../components/input/edit-blobs.vue'
export default {

data() {
    return {
      
        blobs: [],
        options: [
            { 'text' : 'Empty', 'value' : [] },
            { 'text' : 'One Picture', 'value' : ['6df475e7-fed0-4f7b-ab5f-9c3e31da8d54'] },
            { 'text' : 'One PDF', 'value' : ['e2c43a39-0f86-4519-b72d-fed1d4e99c3e'] },
            { 'text' : 'Multiple Files', 'value' : ['6df475e7-fed0-4f7b-ab5f-9c3e31da8d54', 'e2c43a39-0f86-4519-b72d-fed1d4e99c3e', '4ab08fb1-2520-4523-9feb-45583436000c'] },
        ]
    }
},

mounted () {
},

methods: {
},

computed: {
},
    
}
</script>

<style lang="scss" scoped>

</style>